module.exports = " <div class=vux-emotion><slot style=display:none></slot></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/wechat-emotion/index.vue
// module id = 261
// module chunks = 2